import React, { useEffect, useState } from 'react';
import { extend, params, shape, string as stringType, number as numberType, } from '@thd-nucleus/data-sources';
import { Alert, Typography } from '@one-thd/sui-atomic-components';
import { useLoyaltyMembershipDetails } from '../../../hooks/useDataSources';
import { useExperienceContext } from '../../../hooks/useContexts';
export var PTCInfoBanner = function () {
    var _a, _b;
    var isConsumerApp = useExperienceContext().isConsumerApp;
    var _c = (_a = useLoyaltyMembershipDetails()) !== null && _a !== void 0 ? _a : {}, data = _c.data, loading = _c.loading;
    var _d = useState(false), showAlert = _d[0], setShowAlert = _d[1];
    /* Checks the proTiers.benefitTags to determine if the account is a Pro Trade account,
    where a tag's tagName includes 'ProTradeCredit' and tag.value is 'TCConfirmed' */
    var checkIfProHouseAccount = function (proTiers) {
        if (proTiers === undefined)
            return false;
        return proTiers === null || proTiers === void 0 ? void 0 : proTiers.benefitTags.some(function (tag) {
            return tag.tagName.includes('ProTradeCredit') && tag.value === 'TCConfirmed';
        });
    };
    useEffect(function () {
        var _a;
        if (!loading && data) {
            var isProHouseAccount = checkIfProHouseAccount((_a = data === null || data === void 0 ? void 0 : data.loyaltyMembershipDetails) === null || _a === void 0 ? void 0 : _a.proTiers);
            if (isProHouseAccount)
                setShowAlert(true);
        }
    }, [(_b = data === null || data === void 0 ? void 0 : data.loyaltyMembershipDetails) === null || _b === void 0 ? void 0 : _b.proTiers]);
    if (!showAlert || isConsumerApp)
        return null;
    return (React.createElement(Alert, { status: "info", size: "large", onClose: function () {
            setShowAlert(false);
        } },
        React.createElement(Typography, { variant: "body-sm" }, "You can now view your Pro Trade Credit Invoices in Order Details!")));
};
var proTiers = shape({
    benefitTags: shape({
        tagName: stringType(),
        value: stringType(),
    }),
});
PTCInfoBanner.dataModel = extend({
    loyaltyMembershipDetails: params({
        channelId: numberType().isRequired(),
        customerAccountId: stringType().isRequired(),
        userId: stringType().isRequired(),
    }).shape({
        proTiers: proTiers,
    }),
});
